import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { SearchBox } from '../../healtheraComponents';
import useLocationQuery from '../../hooks/useQuery';

const SearchField = ({ onSearch, withClear }) => {
  const { query } = useLocationQuery();
  const [term, setTerm] = useState(query.search);

  return (
    <SearchBox>
      <IconButton onClick={() => onSearch(term)}>
        <SearchIcon />
      </IconButton>
      <TextField
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onSearch(term);
          }
        }}
        InputProps={{ disableUnderline: true }}
        onChange={(e) => setTerm(e.target.value)}
        placeholder="Search"
        autoFocus
        fullWidth
        value={term}
      />
      {withClear && (
        <IconButton
          onClick={() => {
            setTerm('');
            onSearch('');
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </SearchBox>
  );
};

export default SearchField;
